<template>
  <div class="scs-backdrop"></div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  components: {},
  props: [],
};
</script>
<style scoped>
.scs-backdrop {
  position: fixed;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
}

@media print {
  .scs-backdrop {
    display: none;
  }
}
</style>
